<template>
  <div class="md:max-w-60% lg:max-w-68">
    <SelectField
      :label="__('form.choose_week')"
      :options="selectField.options"
      variant="dark"
      v-model="selectField.value"
      @change="changeWeek()"
    />
  </div>
</template>

<script>
import { ref, watchEffect } from 'vue';
import { loadData, weeks } from '@/stores/Rooms';

import SelectField from '@/components/Form/SelectField';

export default {
  components: {
    SelectField
  },
  setup() {
    const selectField = ref({
      value: null,
      options: []
    });

    watchEffect(() => {
      const options = [];
      weeks.value.forEach((week) => {
        const startDate = new Date(week.start);
        let startMonth = startDate.getMonth() + 1;
        let startDay = startDate.getDate();
        if (startMonth < 10) {
          startMonth = `0${startMonth}`;
        }
        if (startDay < 10) {
          startDay = `0${startDay}`;
        }

        const endDate = new Date(week.end);
        let endMonth = endDate.getMonth() + 1;
        let endDay = endDate.getDate();
        if (endMonth < 10) {
          endMonth = `0${endMonth}`;
        }
        if (endDay < 10) {
          endDay = `0${endDay}`;
        }

        options.push({
          value: week.id,
          label: `${startDay}.${startMonth} - ${endDay}.${endMonth}`
        });

        if (week.selected) {
          selectField.value.value = week.id;
        }
      });
      selectField.value.options = options;
    });

    const changeWeek = () => {
      const index = weeks.value.findIndex(
        (week) => week.id === selectField.value.value
      );
      if (index > -1) {
        loadData(weeks.value[index].id);
      }
    };

    return {
      selectField,
      changeWeek
    };
  }
};
</script>
